import React, { useRef } from 'react';
import {
  GET_BUY_FIRE_POLICY_VAR_DETAILS,
  SAVE_QUOTE_FIRE,
} from '../queries';
// import {
//   resetProposerDetails,
//   updateBuyFirePolicyVar,
// } from '../_graphql/state';
import { resetProposerDetails,updateBuyFirePolicyVar } from 'quanta-flows/modules/proposal/fire/state';
import moment from 'moment';
import ProposerDetails from './proposalDetailsFire';
import { useQuery } from '@apollo/client';

export default function ProposerDetailsFire({
  goToStep,
  proceedToNextStep,
  setProceedToNextStep,
  setParentAlerts,
  setLoadingStep,
  setCustomLoadingMessage,
  lobCode,
  lobName,
  productName,
  productCode,
  planName,
  planCode,
  proposalNumber,
  // fireQuote,
  ...props
}) {
  const initLoadRef = useRef([]);

  const {
    loading: loadingBuyFirePolicy,
    error: errorBuyFirePolicy,
    data: dataBuyFirePolicy,
    previousData: previousdataBuyFirePolicy,
  } = useQuery(GET_BUY_FIRE_POLICY_VAR_DETAILS, {
    fetchPolicy: 'cache-first',
    skip: new Set(initLoadRef?.current)?.size >= 1,
    onCompleted: (_) => {
      initLoadRef.current = [...initLoadRef.current, 1];
    },
  });
  const saveQuoteVariables = ({ lob_code, product_code, values }) => {
    return {
      input: {
        quoteNumber: fireQuote?.quoteNumber
          ? `${fireQuote?.quoteNumber}`
          : '',
        intermediary: {
          intermediaryCode: selectedIntermediary?.intermediaryCode
            ? `${selectedIntermediary?.intermediaryCode}`
            : '',
          locationCode: selectedIntermediary?.branchOfficeCode
            ? `${selectedIntermediary?.branchOfficeCode}`
            : '',
          fieldUserCode: selectedIntermediary?.fieldUserCode
            ? `${selectedIntermediary?.fieldUserCode}`
            : '',
        },
        lob: lobCode,
        product: productCode,
        customer,
        businessOfInsured:
          fireQuote?.tabDetails?.customerTabDetails?.customerDetails
            ?.businessOfInsured,
   
          productKg:
          fireQuote?.tabDetails?.customerTabDetails?.productKg
            ?.policyOrCoverType?.code,
        tenure:
          fireQuote?.tabDetails?.customerTabDetails?.policyTypeDetails
            ?.tenure?.code,
        policyStartDate:
          fireQuote?.tabDetails?.customerTabDetails?.policyTypeDetails
            ?.policyStartDate,
        stageIndex: 3,
        finalisedPremium: {
          locNetPremium:
            fireQuote?.finalisedPremium?.locationNetPremium,
          locGST: fireQuote?.finalisedPremium?.locationGST,
          locTotalPremium:
            fireQuote?.finalisedPremium?.locationTotalPremium,
          stampDuty: fireQuote?.finalisedPremium?.stampDuty,
        },
        clauses: {
          default: getDefaultClauses?.map(
            (clause) => clause?.clauseDescription,
          )
            ? getDefaultClauses?.map(
                (clause) => clause?.clauseDescription,
              )
            : [],
          userDefined: values?.userDefinedClauses
            ?.filter((udc) => udc?.clause)
            ?.map((udc) => udc?.clause),
        },
        warranties: {
          default: getDefaultWarranties?.map(
            (warranty) => warranty?.warrantyShortDescription,
          )
            ? getDefaultWarranties?.map(
                (warranty) => warranty?.warrantyShortDescription,
              )
            : [],
          userDefined: values?.userDefinedWarranties
            ?.filter((udw) => udw?.warranty)
            ?.map((udw) => udw?.warranty),
        },
        exclusions: {
          default: getDefaultExclusions?.map(
            (exclusion) => exclusion?.exclusionShortDescription,
          )
            ? getDefaultExclusions?.map(
                (exclusion) => exclusion?.exclusionShortDescription,
              )
            : [],
          userDefined: values?.userDefinedExclusions
            ?.filter((ude) => ude?.exclusion)
            ?.map((ude) => ude?.exclusion),
        },
        conditions: {
          default: getDefaultConditions?.map(
            (condition) => condition?.conditionShortDescription,
          )
            ? getDefaultConditions?.map(
                (condition) => condition?.conditionShortDescription,
              )
            : [],
          userDefined: values?.userDefinedConditions
            ?.filter((udc) => udc?.condition)
            ?.map((udc) => udc?.condition),
        },
        uploadDocuments: values?.documentDetails
          ?.filter(
            (document) =>
              document?.documentName &&
              document?.documentBase64String,
          )
          ?.map((document) => {
            return {
              documentType: {
                code: document?.documentName
                  ? `${document?.documentName}`
                  : '',
                value: document?.documentNameValue
                  ? `${document?.documentNameValue}`
                  : '',
              },
              documentName: document?.documentFileNameWithExtension
                ? `${document?.documentFileNameWithExtension}`
                : '',
              documentSize: document?.documentSizeinKB
                ? `${document?.documentSizeinKB}`
                : '',
              base64EncodedDoc: document?.documentBase64String
                ? `${document?.documentBase64String}`
                : '',
            };
          }),
      },
    };
  };

  return (
    <>
      {!loadingBuyFirePolicy && !errorBuyFirePolicy && (
        <ProposerDetails
          {...{
            REACTIVE_VAR_QUERY: GET_BUY_FIRE_POLICY_VAR_DETAILS,
            SAVE_QUOTE_QUERY: SAVE_QUOTE_FIRE,
            goToStep,
            proceedToNextStep,
            resetProposerDetails,
            saveQuoteVariables,
            setCustomLoadingMessage,
            setLoadingStep,
            setParentAlerts,
            setProceedToNextStep,
            updateReactiveVar: updateBuyFirePolicyVar,
            prePermPincode: dataBuyFirePolicy?.buyFirePolicy?.location
              ?.pincode
              ? dataBuyFirePolicy?.buyFirePolicy?.location?.pincode
              : previousdataBuyFirePolicy?.buyFirePolicy?.location
                  ?.pincode
              ? previousdataBuyFirePolicy?.buyFirePolicy?.location
                  ?.pincode
              : '',
            prePermDistrict: dataBuyFirePolicy?.buyFirePolicy
              ?.location?.district
              ? dataBuyFirePolicy?.buyFirePolicy?.location?.district
              : previousdataBuyFirePolicy?.buyFirePolicy?.location
                  ?.district
              ? previousdataBuyFirePolicy?.buyFirePolicy?.location
                  ?.district
              : '',
            prePermState: dataBuyFirePolicy?.buyFirePolicy?.location
              ?.state
              ? dataBuyFirePolicy?.buyFirePolicy?.location?.state
              : previousdataBuyFirePolicy?.buyFirePolicy?.location
                  ?.state
              ? previousdataBuyFirePolicy?.buyFirePolicy?.location
                  ?.state
              : '',
            prePermCityTownVillage: dataBuyFirePolicy?.buyFirePolicy
              ?.location?.city
              ? dataBuyFirePolicy?.buyFirePolicy?.location?.city
              : previousdataBuyFirePolicy?.buyFirePolicy?.location
                  ?.city
              ? previousdataBuyFirePolicy?.buyFirePolicy?.location
                  ?.city
              : '',
            ...props,
          }}
        />
      )}
    </>
  );
}
